import { DialogOverlay, DialogOverlayActions, DialogOverlayFooter, TextField, Paragraph, Button } from '@fs/zion-ui'
import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

export default function RestoreRelationshipsDialog({ onClose, onRestore, ...overlay }) {
  const { t } = useTranslation()
  const [reason, setReason] = useState('')
  const focusElementRef = useRef()

  return (
    <DialogOverlay
      focusRef={focusElementRef}
      id="restoreConfirmationDialog"
      {...overlay}
      title={t('person.relationships.restoreConfirmationTitle', 'Restore Relationship')}
    >
      <Paragraph size="sm">
        {t('person.relationships.restoreConfirmationBody', 'Are you sure you want to restore this relationship?')}
      </Paragraph>
      <TextField
        ref={focusElementRef}
        label={t('reason', 'Reason')}
        value={reason}
        onChange={(event) => setReason(event.target.value)}
      />
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button id="confirmRestoreRelationshipBtn" onClick={() => onRestore(reason)} type="submit" emphasis="high">
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button id="cancelRestoreRelationshipBtn" onClick={onClose}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
